import { useQuery } from "@tanstack/react-query";
import { getSifreStoritve } from "../services/solevaniaService";
import { toast } from "react-toastify";

export const useSifreStoritve = () => {
  return useQuery({
    queryKey: ["sifreStoritve"],
    queryFn: getSifreStoritve,
  });
};
